import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import Card from "../../../../components/Card";
import cn from "classnames";
import remove_accents from "remove-accents";
import { useSelector, useDispatch } from "react-redux";
import Icon from "../../../../components/Icon";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { DataGridPremium, LicenseInfo, csCZ } from "@mui/x-data-grid-premium";
import { getLicensePremium } from "../../../../features/License";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ContentLoader from "react-content-loader";
import useDarkMode from "@fisch0920/use-dark-mode";
import swal from "sweetalert";
import {
  Form,
  FormData,
  loadingForm,
} from "../../../../components/Modaly/ModalForm/redux/FormSlice";
import ModalForm from "../../../../components/Modaly/ModalForm";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import {
  //ObjednavkyOstatneObjednavkaUrl,
  formRunUrl,
  getUrl,
  menuRunUrl,
  VypisDokladuHTMLObjOstUrl,
  VypisDokladuHTMLReklamaciiSQLUrl,
  VypisDokladuHTMLUrl,
} from "../../../../features/urlHelper";
import { errorHandleDialog } from "../../../../features/errorDialog";
import {
  DatePicker,
  LocalizationProvider,
  csCZ as cz,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import {
  modal,
  modalData,
} from "../../../../components/Modaly/redux/modalSlice";
import { da } from "date-fns/locale";
// data

const data = [];

const Table = ({
  className,
  cis_rekl,
  data,
  prilohy,
  rdl,
  date,
  priznak,
  loading,
  title,
}) => {
  const navigate = useHistory();
  const dispatch = useDispatch();
  const darkMode = useDarkMode(false);
  const modaldata = useSelector(modalData);
  //const logindata = useSelector(loginData);
  const logindata = JSON.parse(
    window.sessionStorage.getItem("logindata") !== null
      ? window.sessionStorage.getItem("logindata")
      : "{}"
  );
  const Formdata = useSelector(FormData);
  const notify_error = (text) => toast.error(text);
  LicenseInfo.setLicenseKey(getLicensePremium());
  const [formName, setFormName] = useState("");
  const [width, setWidth] = useState(window.innerWidth);

  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  function getWidth(width) {
    if (width > 2500) {
      console.log(width - 388);
      return width - 418;
    } else if (width < 2500 && width > 767) {
      return width - 212;
    } else {
      return width - 68;
    }
  }

  function dajVysku(height) {
    if (window.innerWidth > 767) {
      return height - 178;
    } else {
      return height - 130;
    }
  }

  function dajVysku2(height) {
    if (window.innerWidth > 767) {
      return height - 240;
    } else {
      return height - 192;
    }
  }

  function dajVysku3(height) {
    //console.log()
    if (window.innerWidth > 767) {
      if (isClosed()) return (height - 620) / 2;
      else return height - 505;
    } else {
      if (isClosed()) return (height - 577) / 2;
      else return height - 457;
    }
  }

  function typReklamaceNazov(typ_reklamace) {
    switch (typ_reklamace) {
      case 0:
        return "Dodáno nižší množství";
      case 1:
        return "Špatná kvalita – položku zasílám fyzicky zpět na ZMT";
      case 2:
        return "Dodáno vyšší množství (položku si ponechám)";
    }
  }

  const stylingTable = {
    border: 0,

    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    letterSpacing: "normal",
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
      color: darkMode.value ? "white" : "#666d74",
      borderRight: `1px solid ${darkMode.value ? "white" : "#e0e0e0"}`,
    },
    "& .MuiDataGrid-overlay": {
      backgroundColor: "transparent",
      color: darkMode.value ? "white" : "#ACACAC",
    },
    "& .MuiInputBase-input": {
      color: darkMode.value ? "white" : "#ACACAC",
    },
    "& .MuiSvgIcon-root": {
      color: "#a7acaf",
    },
    "& .MuiDataGrid-cell--editable": {
      backgroundColor: "rgb(195, 247, 195)",
      "&:hover": {
        backgroundColor: "rgb(240,250,190)",
      },
      "& .MuiInputBase-root": {
        height: "100%",
      },
    },
    "& .MuiDataGrid-cell": {
      padding: 0.5,
    },
    "& .MuiDataGrid-withBorderColor": {
      borderColor: "transparent",
    },
    "& .Mui-error": {
      backgroundColor: "red",
      color: "white",
    },
    width: getWidth(window.innerWidth),
    height: dajVysku3(window.innerHeight),
    minHeight: 100,
    display: "flex",
    justifyContent: "center",
    alighnItems: "center",
  };

  const theme = createTheme({
    palette: {
      primary: { main: "#F1B600" },
    },
  });
  const columns = [
    {
      field: "polozka",
      headerName: "Položka",
      minWidth: 200,
      width: getWidth(window.innerWidth) * 0.31,
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <div className={styles.nazov}>
            <div className={styles.avatar}>
              <img src={"/images/content/bageta2.png"} alt="Avatar" />
            </div>
            <div className={styles.nazov_kod}>
              <div>{params.row.nazov}</div>
              <div className={styles.znacka}>
                <div className={styles.znackaText}>{params.row.polozka}</div>
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      field: "mj",
      headerName: "MJ",
      minWidth: 55,
      width: getWidth(window.innerWidth) * 0.12,
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return <div title={params.value} className={styles.cell_center}>{params.value}</div>;
      },
    },
    {
      field: "objem",
      headerName: "",
      minWidth: 100,
      width: getWidth(window.innerWidth) * 0.19,
      type: "number",
      headerAlign: "center",
      renderHeader: (params) => {
        return (
          <div className={styles.header}>
            <div className={styles.f_line}>Reklamované</div>
            <div className={styles.s_line}>množství</div>
          </div>
        );
      },
      renderCell: (params) => {
        const valueFormatted = Number(params.row.objem);

        const value = valueFormatted
          .toFixed(params.row.des_mista)
          .replace(/(\d)(?=(\d{3})+\b)/g, "$1 ");
        return <div title={value} className={styles.cell_center}>{value}</div>;
      },
    },
    {
      field: "typ_reklamace",
      hideable: true,
      headerName: "Typ reklamace",
      width: getWidth(window.innerWidth) * 0.19,
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div title={typReklamaceNazov(params.value)} className={styles.polozka_reklamace}>
            <div>{typReklamaceNazov(params.value)}</div>
          </div>
        );
      },
    },
    {
      field: "stav",
      hideable: false,
      headerName: "Stav reklamace",
      minWidth: 150,
      width: getWidth(window.innerWidth) * 0.19,
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        var styl = "";
        var con_styl = "";
        var text = "";
        var icon = "";
        switch (params.value) {
          case "1_ODESLANA":
            styl = "polozka_neutral";
            con_styl = "icon_neutral";
            icon = "fa fa-send-o";
            text = "Odeslaná";
            break;

          case "2_V_RESENI":
            styl = "polozka_neutral";
            con_styl = "icon_neutral";
            icon = "fa fa-clock-o";
            text = "V řešení";
            break;

          case "6_STORNOVANA":
            styl = "polozka_neuz";
            con_styl = "icon_red";
            icon = "fa fa-trash";
            text = "Stornovaná";
            break;

          case "10_UZNANA_END":
          case "10_UZNANA":
            styl = "polozka_vyb";
            con_styl = "icon_green";
            icon = "fa fa-check";
            text = "Uznaná";
            break;

          case "11_NEUZNANA_END":
          case "11_NEUZNANA":
            styl = "polozka_neuz";
            con_styl = "icon_red";
            icon = "fa fa-close";
            text = "Neuznaná";
            break;

          case "12_CUZNANA_END":
          case "12_CUZNANA":
            styl = "polozka_res";
            con_styl = "icon_orange";
            icon = "fa fa-minus";
            text = "Částečně uznaná";
            break;
        }
        return (
          <div title={text}  className={styles[styl]}>
            <div className={styles[con_styl]}>
              <i class={icon}></i>
            </div>
            <div>{text}</div>
          </div>
        );
      },
    },
  ];
  const columns2 = [
    {
      field: "datum_reseni",
      headerName: "",
      minWidth: 150,
      width: getWidth(window.innerWidth) * 0.15,
      headerAlign: "center",
      renderHeader: (params) => {
        return (
          <div className={styles.header}>
            <div className={styles.f_line}>Datum uzavření</div>
            <div className={styles.s_line}>reklamace</div>
          </div>
        );
      },
      renderCell: (params) => {
        var date_ = moment(params?.value).format("DD.MM.YYYY");
        return <div title={date_} className={styles.cell_center}>{date_}</div>;
      },
    },
    {
      field: "mj",
      headerName: "MJ",
      minWidth: 55,
      width: getWidth(window.innerWidth) * 0.1,
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return <div title={params.value} className={styles.cell_center}>{params.value}</div>;
      },
    },
    {
      field: "objem",
      headerName: "",
      minWidth: 100,
      width: getWidth(window.innerWidth) * 0.15,
      type: "number",
      headerAlign: "center",
      renderHeader: (params) => {
        return (
          <div className={styles.header}>
            <div className={styles.f_line}>Množství</div>
            <div className={styles.s_line}>uznané</div>
          </div>
        );
      },
      renderCell: (params) => {
        const valueFormatted = Number(params.value - params.row.objem_neuznany);
        console.log(params.value, params.row.objem_neuznany);
        const value = valueFormatted
          .toFixed(params.row.des_mista)
          .replace(/(\d)(?=(\d{3})+\b)/g, "$1 ");
        return <div title={value} className={styles.cell_center}>{value}</div>;
      },
    },
    {
      field: "objem_neuznany",
      headerName: "",
      minWidth: 100,
      width: getWidth(window.innerWidth) * 0.15,
      type: "number",
      headerAlign: "center",
      renderHeader: (params) => {
        return (
          <div className={styles.header}>
            <div className={styles.f_line}>Množství</div>
            <div className={styles.s_line}>neuznané</div>
          </div>
        );
      },
      renderCell: (params) => {
        const valueFormatted = Number(params.value);

        const value = valueFormatted
          .toFixed(params.row.des_mista)
          .replace(/(\d)(?=(\d{3})+\b)/g, "$1 ");
        return <div title={value} className={styles.cell_center}>{value}</div>;
      },
    },
  ];

  function formatujDatum(isoString) {
    console.log(isoString);
    const date_ = new Date(isoString);
    console.log(date_);
    // Extracting day, month, and year
    const day = String(date_.getDate()).padStart(2, "0");
    const month = String(date_.getMonth() + 1).padStart(2, "0"); // Měsíce jsou indexovány od 0, proto +1
    const year = date_.getFullYear();

    // Formatting into dd.mm.yyyy
    return `${day}.${month}.${year}`;
  }

  function back() {
    switch (priznak) {
      case "base":
        navigate.push("/reklamaceSQL");
        break;
      case "nova":
        navigate.push("/reklamaceSQL_nova");
        break;
      case "otvorena":
        navigate.push("/reklamaceSQL/resitel/otvorena");
        break;
      case "uzavreta":
        navigate.push("/reklamaceSQL/resitel/uzavreta");
        break;
      default:
        navigate.push("/");
        break;
    }
  }

  function isClosed() {
    if (data[0] === undefined) return false;

    switch (data[0].stav) {
      case "1_ODESLANA":
      case "2_V_RESENI":
      case "6_STORNOVANA":
        return false;

      case "10_UZNANA_END":
      case "10_UZNANA":
      case "11_NEUZNANA_END":
      case "11_NEUZNANA":
      case "12_CUZNANA_END":
      case "12_CUZNANA":
        return true;
    }
  }

  function dajDoklad(data_, field) {
    if (data_[field] !== undefined && data_[field] !== "") {
      switch (field) {
        case "doklad_prj":
          return (
            <div className={styles.dokl}>
              <div className={styles.icon_pdf}>
                <i class="fa fa-file-pdf-o"></i>
              </div>
              <div>Číslo dokladu příjmu: {data[0].doklad_prj}</div>
            </div>
          );
        case "doklad_odp":
          return (
            <div className={styles.dokl}>
              <div className={styles.icon_pdf}>
                <i class="fa fa-file-pdf-o"></i>
              </div>
              <div>Číslo dokladu odpisu: {data[0].doklad_odp}</div>
            </div>
          );
        case "doklad_prv":
          return (
            <div className={styles.dokl}>
              <div className={styles.icon_pdf}>
                <i class="fa fa-file-pdf-o"></i>
              </div>
              <div>Doklad výroby, který ponižujeme: {data[0].doklad_prv}</div>
            </div>
          );
        case "doklad_dl":
          return (
            <div className={styles.dokl}>
              <div className={styles.icon_pdf}>
                <i class="fa fa-file-pdf-o"></i>
              </div>
              <div>Číslo dodatečného DL: {data[0].doklad_dl}</div>
            </div>
          );
      }
    } else return <></>;
  }

  return (
    <Card>
      <div
        className={styles.layout}
        style={{ height: dajVysku(window.innerHeight) }}
      >
        <div className={styles.header_cont}>
          <div className={styles.back}>
            <button
              onClick={() => {
                back();
              }}
              className={styles.buttonPS}
            >
              <div className={styles.buttonPSI}>
                <Icon name="arrow-left" size="20" />
              </div>
              <div className={styles.buttonPST}>Zpět</div>
            </button>
          </div>
          <div className={styles.nadpis_vytvoril}>
            <div className={styles.nadpis}>
              Reklamace {cis_rekl} - Centrální sklad Žiželice ZMT -
              {formatujDatum(date)}
            </div>
            <div className={styles.vytvoril}>
              Vytvořil: {data[0] !== undefined && data[0].x__adduser}
            </div>
          </div>
          <div className={styles.buttonPS}></div>
        </div>

        <div
          style={{ height: dajVysku2(window.innerHeight) }}
          className={styles.main}
        >
          {loading ? (
            <ContentLoader
              speed={2}
              width={"100%"}
              height={300}
              backgroundColor={darkMode.value ? "#1e2730" : "#f3f3f3"}
              foregroundColor={darkMode.value ? "#2d3641" : "#ecebeb"}
            >
              <rect x="3%" y="5%" rx="3" ry="3" width={"100%"} height="80%" />
            </ContentLoader>
          ) : (
            <>
              <ThemeProvider theme={theme}>
                <DataGridPremium
                  sx={stylingTable}
                  localeText={
                    csCZ.components.MuiDataGrid.defaultProps.localeText
                  }
                  {...{
                    rows: data,
                    columns: columns,
                  }}
                  columnHeaderHeight={40}
                  disableAutoFocus
                  disableColumnMenu
                  defaultGroupingExpansionDepth={-1}
                  hideFooter
                  rowHeight={40}
                  groupingColDef={{
                    leafField: "nazov",
                    headerClassName: "weekend6_help_nadpis",
                    cellClassName: "weekend6_help_cell",
                  }}
                />
              </ThemeProvider>
            </>
          )}
          <div className={styles.koment}>
            <div>Komentář od zadavatele</div>
            <textarea
              disabled
              value={data[0] !== undefined && data[0].poznamka}
              className={styles.textarea}
            ></textarea>
          </div>
          <div className={styles.fotky}>
            {prilohy.map((priloha) => {
              var url =
                getUrl() +
                `api/reklamaceSQL/priloha/get/${priloha.id}/${false}`;
              console.log(url);
              return (
                <img
                  onClick={() => {
                    var name = priloha.filename;
                    window.open(url, name, "width=800, height=600");
                    return false;
                  }}
                  src={url}
                  alt={priloha.filename}
                  width="80"
                  height="80"
                />
              );
            })}
          </div>
          <div className={styles.objednat_area_3}>
            <button
              onClick={async () => {
                await axios
                  .post(
                    VypisDokladuHTMLReklamaciiSQLUrl,
                    {
                      doklad: cis_rekl,
                      stredisko:
                        logindata.UserData.vybrane_stredisko !== undefined
                          ? logindata.UserData.vybrane_stredisko.kod
                          : null,
                      ico:
                        logindata.UserData.ico !== undefined
                          ? logindata.UserData.ico
                          : null,
                      fotky: prilohy,
                      url: getUrl(),
                    },
                    {
                      headers: { Authorization: "Bearer " + logindata.Token },
                    }
                  )
                  .then(function (response) {
                    if (response.data.html !== null) {
                      dispatch(
                        modal({
                          data: {
                            ...modaldata,
                            ZobrazHtml: true,
                            HtmlData: response.data.html,
                            ZobrazHtml_print: response.data.print,
                            ZobrazHtml_text: response.data.text,
                          },
                        })
                      );
                    }
                  })
                  .catch(function (error) {
                    errorHandleDialog(error.response, navigate, dispatch);
                  });
              }}
              className={styles.polozka_doklad}
            >
              <div className={styles.icon_pdf}>
                <i class="fa fa-file-pdf-o"></i>
              </div>
              <div>Doklad k reklamaci {cis_rekl}</div>
            </button>
          </div>
          <>
            {isClosed() && data[0] !== undefined ? (
              <>
                {loading ? (
                  <ContentLoader
                    speed={2}
                    width={"100%"}
                    height={300}
                    backgroundColor={darkMode.value ? "#1e2730" : "#f3f3f3"}
                    foregroundColor={darkMode.value ? "#2d3641" : "#ecebeb"}
                  >
                    <rect
                      x="3%"
                      y="5%"
                      rx="3"
                      ry="3"
                      width={"100%"}
                      height="80%"
                    />
                  </ContentLoader>
                ) : (
                  <>
                    <ThemeProvider theme={theme}>
                      <DataGridPremium
                        sx={stylingTable}
                        localeText={
                          csCZ.components.MuiDataGrid.defaultProps.localeText
                        }
                        {...{
                          rows: data,
                          columns: columns2,
                        }}
                        columnHeaderHeight={40}
                        disableAutoFocus
                        disableColumnMenu
                        defaultGroupingExpansionDepth={-1}
                        hideFooter
                        rowHeight={40}
                        groupingColDef={{
                          leafField: "nazov",
                          headerClassName: "weekend6_help_nadpis",
                          cellClassName: "weekend6_help_cell",
                        }}
                      />
                    </ThemeProvider>
                  </>
                )}
                <div className={styles.koment}>
                  <div>Komentář od řešitele</div>
                  <textarea
                    disabled
                    value={data[0] !== undefined && data[0].poznamka_reseni}
                    className={styles.textarea}
                  ></textarea>
                </div>
                <div className={styles.objednat_area_2}>
                  <div className={styles.objednat_area}>
                    <>{dajDoklad(data[0], "doklad_prj")}</>
                    <>{dajDoklad(data[0], "doklad_odp")}</>
                    <>{dajDoklad(data[0], "doklad_prv")}</>
                    <>{dajDoklad(data[0], "doklad_dl")}</>
                  </div>
                  <div className={styles.objednat_area}>
                    {rdl.map((file_) => {
                      return (
                        <button
                          onClick={async () => {
                            try {
                              console.log(file_);
                              // url na prilohu
                              var url =
                                getUrl() +
                                `api/reklamaceSQL/priloha/get/${
                                  file_.id
                                }/${false}`;

                              // Zavolanie API, ktoré vracia súbor (napr. PDF) ako FileContentResult
                              const response = await axios.get(url, {
                                responseType: "blob", // Dôležité! Aby Axios vedel, že očakáva binárny obsah
                              });

                              // Vytvorenie Blob objektu z odpovede
                              const file = new Blob([response.data], {
                                type: "application/pdf",
                              });

                              // Vytvorenie URL pre Blob objekt
                              const fileURL = URL.createObjectURL(file);

                              // Otvorenie nového okna a nastavenie jeho umiestnenia na Blob URL
                              const pdfWindow = window.open(""); // Otvorenie prázdneho okna
                              if (pdfWindow) {
                                pdfWindow.location.href = fileURL; // Nastavenie URL pre otvorené okno
                              } else {
                                console.log(
                                  "Nemôžem otvoriť nové okno. Skontrolujte nastavenia prehliadača."
                                );
                              }
                            } catch (error) {
                              console.log("Chyba pri načítaní PDF:", error);
                            }
                          }}
                          className={styles.polozka_doklad}
                        >
                          <div className={styles.icon_pdf}>
                            <i class="fa fa-file-pdf-o"></i>
                          </div>
                          <div>Doklad {file_.nazov}</div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        </div>
      </div>
    </Card>
  );
};

export default Table;
